import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { CrossPortalPredicate, CrossTabPredicate, ExcludeSelfPredicate, MatchingTagPredicate, SameWindowPredicate, TargetAppPredicate } from './audience-filter-predicate';
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
var _predicates = /*#__PURE__*/_classPrivateFieldLooseKey("predicates");
export class AudienceFilter {
  constructor(initial = {}) {
    Object.defineProperty(this, _instance, {
      writable: true,
      value: void 0
    });
    this.byTag = tag => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].tags.add(tag);
      return this;
    };
    this.byApplication = ({
      name
    }) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].apps.add(name);
      return this;
    };
    this.sameWindow = (targetOnlySameWindow = true) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].sameWindow = targetOnlySameWindow;
      return this;
    };
    this.excludeSelf = (excludeSelfFromRecipients = true) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].excludeSelf = excludeSelfFromRecipients;
      return this;
    };
    this.crossTab = (allowCrossTab = true) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].allowCrossTab = allowCrossTab;
      return this;
    };
    this.crossPortal = (allowCrossPortal = true) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].allowCrossPortal = allowCrossPortal;
      return this;
    };
    this.build = () => _classPrivateFieldLooseBase(this, _instance)[_instance];
    this.isTargetAudience = context => {
      return AudienceFilter.isTargetAudience(_classPrivateFieldLooseBase(this, _instance)[_instance], context);
    };
    _classPrivateFieldLooseBase(this, _instance)[_instance] = Object.assign({
      tags: new Set(),
      apps: new Set(),
      excludeSelf: false,
      sameWindow: false,
      allowCrossTab: false,
      allowCrossPortal: false
    }, initial);
  }
  static builder() {
    return new AudienceFilter();
  }
  static from(instance) {
    return new AudienceFilter(instance);
  }
}
Object.defineProperty(AudienceFilter, _predicates, {
  writable: true,
  value: [new TargetAppPredicate(), new MatchingTagPredicate(), new ExcludeSelfPredicate(), new SameWindowPredicate(), new CrossTabPredicate(), new CrossPortalPredicate()]
});
AudienceFilter.isTargetAudience = (audience, context) => _classPrivateFieldLooseBase(AudienceFilter, _predicates)[_predicates].every(predicate => predicate.isTargetAudience(audience, context));